import { CheckSessionCommand, AccountDto } from '@/Application/Authentication'
import {
  AccountRepository,
  AccountId,
  SessionNotValidError
} from '@/Domain/Account'
import { TokenStorage } from '@/Domain/Account/TokenStorage'
import { Api410Error } from '@/Domain/ApiClient'

export class CheckSessionCommandHandler {
  private _accountRepository: AccountRepository
  private _tokenStorage: TokenStorage

  constructor (accountRepository: AccountRepository, tokenStorage: TokenStorage) {
    this._accountRepository = accountRepository
    this._tokenStorage = tokenStorage
  }

  async handle (command: CheckSessionCommand): Promise<AccountDto> {
    try {
      const accountId = new AccountId(command.accountId())
      const response = await this._accountRepository.checkSession(accountId)
      this._tokenStorage.storeToken(response.token())
      return AccountDto.fromAccount(response)
    } catch (error) {
      if (error instanceof Api410Error) {
        return Promise.reject(error)
      }
      return Promise.reject(new SessionNotValidError(error.message))
    }
  }
}
